export const NumberOfHistoricalDashboardIds = 4;
